export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const TEACHER_TOKEN_KEY = "tennis_teacher_token";

export const toISODate = (d) => {
  const p = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
};

export const fromISODate = (s) => {
  const [y, m, d] = s.split("-").map(Number);
  return new Date(y, m - 1, d);
};

export const shiftDate = (s, days) => {
  const d = fromISODate(s);
  d.setDate(d.getDate() + days);
  return toISODate(d);
};

export const formatLongDate = (s) =>
  fromISODate(s).toLocaleDateString("it-IT", { weekday: "long", day: "numeric", month: "long" });

export const formatShortDate = (s) =>
  s ? fromISODate(s).toLocaleDateString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric" }) : "";

export const studentLabel = (s) => `${s.nome} ${s.cognome}`.trim() + (s.anno ? ` (${s.anno})` : "");

export const lessonTitle = (l) => {
  const names = l.parts.map((p) => p.group_nome).join(" + ");
  return l.type === "athletic" ? `Atletica · ${names}` : names;
};

// Combined record status: registered only when every group of the lesson has a record
export const lessonRecord = (l) => (l.parts.every((p) => p.record) ? l.parts[0].record : null);

export const downloadBlob = (data, filename) => {
  const url = window.URL.createObjectURL(new Blob([data]));
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};
